var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBadgeBgHover = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 130,
  height: 148,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#E8E8E8",
  d: "m66.732 1.56 60.999 34.724a3.5 3.5 0 0 1 1.769 3.042v69.348a3.5 3.5 0 0 1-1.769 3.042l-61 34.723a3.5 3.5 0 0 1-3.462 0l-61-34.723A3.5 3.5 0 0 1 .5 108.674V39.326a3.5 3.5 0 0 1 1.769-3.042l61-34.723a3.5 3.5 0 0 1 3.462 0Z"
})));
export { SvgBadgeBgHover as ReactComponent };
export default __webpack_public_path__ + "b0fc3e0e66cef46d0255562201cde710.svg";